
export default {
    proverb: [
        "「全ての道はローマに通ず！」ーローマのことわざー",
        "「人の世はこれ胡蝶の夢なり！」 ー荘子ー",
        "「善く敵に勝つ物は争わず」ー老子ー",
        "「迷わずいけよ、行けば分かるさ！」 ーアントニオ猪木ー",
        "「その日その日が一年中の最善の日！」 ーラルフ・ワルド・エマーソンー",
        "「チャンスは貯蓄できない！」 ー樋口 廣太郎ー",
        "「生きるとは呼吸することではない。行動することだ」ージャン・ジャック・ルソー ー",
        "「罰がなければ、逃げるたのしみもない！」ー安部公房『砂の女』ー",
        "「最も多くの人間を喜ばせたものが、最も大きく栄える」ー徳川家康ー",
        "「次勝てばそれでよし」ー後藤又兵衛ー",
        "「一芸に熟達せよ 多芸を欲張るものは巧みならず」ー長宗我部元親ー",
        "「すぐわかりましたという人間に、 わかったためしはない」ー小早川隆景ー",
        "「時を移さずに行うのが勇将の本望である。早く出立せよ」ー伊達政宗ー",
        "「人城を頼らば、城人を捨てん」ー織田信長ー",
        "「若者は勇猛に頼り、壮年は相手の強弱を測って戦う」ー伊達政宗ー",
        "「怒りは敵と思え」ー徳川家康ー",
        "「学んで思わざれば罔（くら）し。思うて学ばざれば殆（あやう）し」ー孔子ー",
        "「為せば成る　為さねば成らぬ成る業を　成らぬと捨つる人のはかなさ」ー武田信玄ー",
        "「臆病者の目には、常に敵が大軍に見える　ー織田信長ー",
        "「戦わずして勝ちを得るのは、良将の成すところである」ー豊臣秀吉ー",
        "「いさめてくれる部下は、一番槍をする勇士より値打ちがある」ー徳川家康ー",
        "「是非に及ばず」ー織田信長ー",
        "「燕雀いずくんぞ鴻鵠の志を知らんや」ー司馬遷『史記』ー",
        "「学問とは、人間はいかに生きていくべきかを学ぶものだ」ー吉田松陰ー",
        "「人のまねをせずに、その身に応じ、武器は自分の使いやすいものでなければならぬ」ー宮本武蔵ー",
        "「心に勇あるときは、悔やむことなし」ー上杉謙信ー",
    ]
}

